<template>
    <div class="w-64">
        <label class="block text-sm font-bold mb-1" for="phone">
            Phone Number
        </label>
        <input
            id="phone"
            ref="phone"
            name="phone"
            class="border shadow-sm w-full py-2 px-3"
            :value="phone"
            @input="updatePhone"
            placeholder="(###) ###-####"
            v-maska
            data-maska="(###) ###-####"
        />
    </div>
</template>
<script>
import { mapActions } from 'pinia';
import { useAppStore } from '@/store/app';

import { vMaska } from 'maska/vue';

export default {
    props: {
        phone: {
            type: String,
            default: null,
        },
    },
    directives: { maska: vMaska },
    data: () => ({
        errors: [],
    }),
    methods: {
        ...mapActions(useAppStore, ['setPhone']),
        updatePhone(el) {
            if (el.detail && el.detail.completed) {
                this.$refs.phone.classList.remove('border-rose-700');
                this.setPhone(el.target.value);
                ApiService.apiCall('/user/setting', 'put', {
                    setting: 'phone',
                    value: el.target.value,
                })
                    .then((response) => {})
                    .catch((response) => {
                        this.$root.handleHttpStatus(response);
                    });
            }
        },
    },
    mounted() {
        this.setPhone(this.phone);
    },
};
</script>
